import lineHeight from 'line-height';
import './DoubleTextBtn.scss';

export default class DoubleTextBtn {
  constructor(element) {
    this.element = element;
    this.className = 'double-text';
    this.init();
  }

  toggleClasses(e, direction) {
    const { offsetY } = e;
    const { offsetHeight } = this.element;
    this.element.classList.toggle('is-bot_in', direction === 'in' && offsetY > offsetHeight / 2);
    this.element.classList.toggle('is-bot_out', direction === 'out' && offsetY > offsetHeight / 2);
    this.element.classList.toggle('is-top_in', direction === 'in' && offsetY < offsetHeight / 2);
    this.element.classList.toggle('is-top_out', direction === 'out' && offsetY < offsetHeight / 2);
  }

  createLabel(className = '') {
    const text = $(this.element).find('span').text();
    return $(`
      <div class="${this.className}__label ${className ? `${this.className}__label_${className}` : ''}">
        <p>${text}</p>
      </div>
      `);
  }

  addEvents() {
    this.element.addEventListener('mouseenter', (e) => {
      this.toggleClasses(e, 'in');
    });
    this.element.addEventListener('mouseleave', (e) => {
      this.toggleClasses(e, 'out');
    });
  }

  createContainer() {
    return $(`<div class="${this.className}__container" />`);
  }

  init() {
    const height = lineHeight(this.element);
    const $label = this.createLabel('top');
    const $labelActive = this.createLabel('bot');
    const $container = this.createContainer();
    $container
      .css({ height, 'line-height': `${height}px` })
      .append($label)
      .append($labelActive);
    $(this.element)
      .addClass(this.className)
      .find('span')
      .replaceWith($container);
    // .append();
  }
}



// WEBPACK FOOTER //
// ./scripts/elements/DoubleTextBtn/DoubleTextBtn.js